module.exports = __webpack_public_path__ + "media/luxury-2026/mianus-front-drone-960-d002d225.jpg";